import { makeStyles } from '@material-ui/core'

export const useStyles = makeStyles((theme) => ({
  updateVaccineContainer: {
    display: 'flex',
    flexWrap: 'wrap',
    padding: 8,
  },

  updateVaccineButton: {
    marginTop: 21,
    width: 112,
  },

  updateVaccineButtonCancel: {
    marginTop: 21,
    width: 112,
    backgroundColor: theme.app.colors.text.light,
    color: theme.palette.primary.main,
    border: `2px solid ${theme.palette.primary.main}`,
  },

  updateVaccineInput: {
    width: '100%',
  },

  updateVaccineButtonContainer: {
    display: 'flex',
    marginLeft: 'auto',
    alignItems: 'center',
    justifyContent: 'flex-end',
    '& button': {
      margin: '0 0 0 16px',
    },
  },
}))
